import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import VehicleDetailSteps from '../components/VehicleDetailSteps'

const VehicleDetailsPage = () => {
  const location = useLocation()
  const vehicle = location.state?.vehicle || {}
  const headerTitle = vehicle.brand || vehicle.make || 'Fahrzeug'
  const headerSubtitle = vehicle.modelLine || vehicle.model || vehicle.variant || ''
  return (
    <div className="bg-[#f3f4f6] text-gray-900 min-h-screen">
      <header className="bg-[#9c00b3] text-white px-4 py-4 flex items-center gap-3 shadow">
        <Link to="/" className="flex items-center">
          <img src="/images/Logo.svg" alt="autoverkaufen.de" className="h-12 w-auto bg-white rounded-xl p-2" />
        </Link>
        <div className="leading-tight flex-1">
          <div className="text-base font-semibold">{headerTitle}</div>
          {headerSubtitle ? <div className="text-sm text-white/90">{headerSubtitle}</div> : null}
        </div>
        <button className="text-sm font-semibold underline" aria-label="edit">
          Bearbeiten
        </button>
      </header>

      <div className="px-4 py-5 max-w-3xl mx-auto">
        <h1 className="text-lg font-semibold mb-4 leading-tight text-center">
          Fahrzeugdetails ergaenzen und Bestpreis erhalten
        </h1>
        <VehicleDetailSteps className="mt-1" />
      </div>

      <footer className="bg-[#323845] text-gray-200 pt-6 pb-8 mt-6">
        <div className="max-w-5xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-3 text-sm">
            <div>
              <span className="text-[#a6ff00]">autoverkaufen.de</span> - Die beste Wahl
            </div>
            <div>Haeufige Fragen</div>
            <div>Kontakt</div>
            <div>Datenschutz</div>
            <div>Impressum</div>
            <div>allgemeine Nutzungsbedingungen</div>
          </div>
          <div className="flex justify-center items-center">
            <div className="w-14 h-14 rounded-full bg-[#0099ff] text-white flex items-center justify-center text-2xl">
              Tel
            </div>
          </div>
        </div>
        <div className="mt-6">
          <button className="w-full bg-[#0099ff] text-white h-10 text-sm">Cookie-Einstellungen</button>
        </div>
      </footer>
    </div>
  )
}

export default VehicleDetailsPage
